import { Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import SkeletonLoader from '../SkeletonLoader';

const FunnelChartLoader: FC<PropsWithChildren<FunnelChartLoaderProps>> = ({
  noResults,
  loading,
  isScanning,
  children,
}) => {
  if (noResults) {
    if (isScanning) {
      return <SkeletonLoader loading message='Waiting for issues' />;
    } else if (loading) {
      return <SkeletonLoader loading message='Loading' />;
    }
    return (
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        No data to show
      </Typography>
    );
  }
  return <>{children}</>;
};

interface FunnelChartLoaderProps {
  isScanning: boolean;
  loading: boolean;
  noResults: boolean;
}

export default FunnelChartLoader;
